// ============================================================
// SurfaceCard — Brand Guide v2 · the canonical panel container.
//
// Elevation 1–5 from the purple substrate scale. One accent per
// section: pass `accent` to tint the border, not the background.
// `live={true}` turns on a top-edge gradient line + breathe glow
// — only use for surfaces that reflect real, breathing state.
// ============================================================

const LEVEL_BG = {
  1: 'var(--sc-surface-1, rgba(123,94,167,0.02))',
  2: 'var(--sc-surface-2, rgba(123,94,167,0.04))',
  3: 'var(--sc-surface-3, rgba(123,94,167,0.06))',
  4: 'var(--sc-surface-4, rgba(123,94,167,0.08))',
  5: 'var(--sc-surface-5, rgba(123,94,167,0.12))',
}

export default function SurfaceCard({
  level = 1,
  accent,
  live = false,
  padding = 18,
  radius = 12,
  children,
  style: styleOverride,
  ...rest
}) {
  const borderColor = accent
    ? `${accent}26`
    : 'var(--sc-border-rest, rgba(123,94,167,0.06))'

  return (
    <div
      {...rest}
      style={{
        position: 'relative',
        overflow: 'hidden',
        padding,
        borderRadius: radius,
        background: LEVEL_BG[level] || LEVEL_BG[1],
        border: `1px solid ${borderColor}`,
        boxShadow: live && accent ? `0 0 18px ${accent}14` : 'none',
        animation: live ? 'sc-breathe 4s ease infinite' : 'none',
        ...styleOverride,
      }}
    >
      {live && accent && (
        <div
          aria-hidden
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 1,
            background: `linear-gradient(90deg, ${accent}66 0%, ${accent}22 40%, transparent 80%)`,
          }}
        />
      )}
      {children}
    </div>
  )
}
